export default __webpack_public_path__ + "media/images/fancybox/fancy_title_main-6cf1de6961818cca798c3fe3525d1755.png";